export const Forms = {
    CREATE_MEMBERSHIP: 'createMembership',
};
